// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"db","heading":"eb","screenReadersOnly":"fb"};